<template>
  <v-dialog v-model="popSignupMenu" max-width="350px">
    <div slot="activator">
      <v-list color="white" two-line>
        <v-list-tile >
          <v-list-tile-action>
            <v-icon x-large color="secondary">border_color</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="primary--text">Create an account</v-list-tile-title>
            <v-list-tile-sub-title>Register to save your custom designs</v-list-tile-sub-title>
          </v-list-tile-content>
          <v-spacer></v-spacer>
          <v-list-tile-action>
            <v-icon color="secondary">arrow_forward</v-icon>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </div>
    <v-card>
      <v-toolbar color="white" class="elevation-0 iotyblack--text">
        <v-toolbar-title>Create a new account</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-container>
          <form @submit.prevent="onSignupClicked">
            <v-layout row>
              <v-flex xs12>
                <v-text-field name="email" v-model="email" label="E-mail" :rules="[rules.required, rules.email]"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-text-field name="password" v-model="password" label="Password" type="password" :rules="[rules.required]"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <div v-if="gError" class="mt-2 error--text">{{ gError.message }}</div>
                <v-btn type="submit" class="primary primary--text mt-4" block outline :disabled="errors.any()">
                  Create Account
                  <span slot="loader" class="custom-loader">
                    <v-icon light>cached</v-icon>
                  </span>
                </v-btn>
              </v-flex>
            </v-layout>
          </form>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    email: '',
    password: '',
    popSignupMenu: false,
    rules: {
      required: value => !!value || 'Required.',
      counter: value => value.length <= 20 || 'Max 20 characters',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    }
  }),
  watch: {
    termsAccepted: {
      handler(newDate, oldDate) {
        if(newDate !== '')this.onTermsAccepted()
      }
    }
  },
  computed: {
    authLoading() {
      return this.$store.state.auth.authLoading
    },
    gError() {
      return this.$store.state.auth.gError
    },
    termsAccepted() {
      return this.$store.getters['term/termsTimestamp']
    }
  },
  methods: {
    onSignupClicked() {
      this.$emit('onSignupClicked')
      this.$store.dispatch('term/checkTerms')
    },
    onTermsAccepted() {
      console.log("TCL: onTermsAccepted -> onTermsAccepted")
      this.$store.dispatch('signUserUp', {
        email: this.email,
        password: this.password
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/auth/Signup.vue